/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Own_TitleInputs */

const en_history_own_title = /** @type {(inputs: History_Own_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout`)
};

const pl_history_own_title = /** @type {(inputs: History_Own_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening`)
};

/**
* | output |
* | --- |
* | "Workout" |
*
* @param {History_Own_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const history_own_title = /** @type {((inputs?: History_Own_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Own_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_history_own_title(inputs)
	return en_history_own_title(inputs)
});